import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { useSelector } from 'react-redux'

import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledButtonDropdown,
} from 'reactstrap'
import { FaEllipsisV, FaRegCopy, FaRegTrashAlt } from 'react-icons/fa'

import { SearchSelect, Input, NumberInput } from '../../../../input'
import { CustomDatePicker } from '../../../../datepicker'
import { FONTS } from '../../../../../constants'
import { saleProductSelector } from '../../../../../selectors'

export const credit_term = [
  { label: '15', value: '15' },
  { label: '30', value: '30' },
  { label: '45', value: '45' },
  { label: '90', value: '90' },
]

const DropdownActions = ({ id, setShowCopyModal, copyRow, deleteRow }) => {
  return (
    <UncontrolledButtonDropdown>
      <Toggle>
        <FaEllipsisV />
      </Toggle>
      <DropdownMenu>
        <Item onClick={ () => copyRow(id) }>
          <FaRegCopy />
          Copy a row
        </Item>
        <Item onClick={ () => setShowCopyModal({ show: true, id }) }>
          <FaRegCopy />
          Copy more
        </Item>
        <Item onClick={ () => deleteRow(id) }>
          <FaRegTrashAlt />
          Delete
        </Item>
      </DropdownMenu>
    </UncontrolledButtonDropdown>
  )
}

export const InputRow = (props) => {
  const [saleProducts, setSaleProducts] = useState([])
  const _saleProducts = useSelector(saleProductSelector.getSaleProductList)

  const {
    id,
    vendor,
    isEdit,
    isImplementing,
    handleChangeInput,
    handleChangeDate,
    handleChangeSelect,
    setShowCopyModal,
    copyRow,
    deleteRow,
  } = props

  useEffect(() => {
    setSaleProducts(_saleProducts.map(p => {
      return {
        label: p.name,
        value: p._id,
      }
    }))
  }, [_saleProducts])

  return (
    <Root>
      <Text>{ vendor.sub_project_code }</Text>
      {/* <InputWrapper is_edit={ (isEdit && isImplementing).toString() }>
        <Input
          name='sub_project_code'
          placeholder='Enter Sub-Project Code'
          value={ vendor.sub_project_code }
          disabled={ !isEdit || isImplementing }
          onChange={ e => handleChangeInput(e, id) }
        />
        <div className='tooltip'>Cannot edit when the project is on implementing</div>
      </InputWrapper> */}
      <InputWrapper /* is_edit={ (isEdit && isImplementing).toString() } */>
        <SearchSelect
          name='product_id'
          placeholder='Select Sale Group'
          isDisabled={ !isEdit /* || isImplementing */ }
          onChange={ e => handleChangeSelect(e, id, 'product_id') }
          value={ saleProducts.find(p => p.value === vendor.product_id) }
          options={ saleProducts }
        />
        <div className='tooltip'>Cannot edit when the project is on implementing</div>
      </InputWrapper>
      <Input
        name='description'
        placeholder='Enter Description'
        value={ vendor.description }
        disabled={ !isEdit }
        onChange={ e => handleChangeInput(e, id) }
      />
      <CustomDatePicker
        name='delivery_date'
        autoComplete='off'
        selected={ vendor.delivery_date ? moment(vendor.delivery_date) : null }
        dateFormat='DD/MM/YYYY'
        showYearDropdown
        showMonthDropdown
        disabled={ !isEdit }
        onChange={ e => handleChangeDate(e, id) }
      />
      <SearchSelect
        name='credit_term'
        placeholder='Select Credit Term'
        isDisabled={ !isEdit }
        onChange={ e => handleChangeSelect(e, id, 'credit_term') }
        value={ credit_term.find(t => t.value === vendor.credit_term) }
        options={ credit_term }
      />
      <InputWrapper /* is_edit={ (isEdit && isImplementing).toString() } */>
        <NumberInput
          name='cost'
          value={ vendor.cost }
          allowEmptyFormatting={ true }
          thousandSeparator={ true }
          decimalScale={ 2 }
          fixedDecimalScale={ true }
          disabled={ !isEdit /* || isImplementing */ }
          onChange={ e => handleChangeInput(e, id) }
        />
        <div className='tooltip'>Cannot edit when the project is on implementing</div>
      </InputWrapper>
      <InputWrapper is_edit={ (isEdit && isImplementing).toString() }>
        <NumberInput
          name='price'
          value={ vendor.price }
          allowEmptyFormatting={ true }
          thousandSeparator={ true }
          decimalScale={ 2 }
          fixedDecimalScale={ true }
          disabled={ !isEdit || isImplementing }
          onChange={ e => handleChangeInput(e, id) }
        />
        <div className='tooltip'>Cannot edit when the project is on implementing</div>
      </InputWrapper>
      { isEdit && !isImplementing &&
        <DropdownActions
          id={ id }
          setShowCopyModal={ setShowCopyModal }
          copyRow={ copyRow }
          deleteRow={ deleteRow }
        />
      }
    </Root>
  )
}

const Root = styled.div`
  width: 100%;
  height: 46px;
  display: grid;
  align-items: center;
  grid-gap: 10px;
  grid-template-columns: 1fr 1fr 3fr 1fr 1fr 1fr 1fr 25px;
  padding: 0 24px;
  background: #FFFFFF;
  margin-top: 1px;

  :nth-child(1) {
    margin: 0;
  }
`

const Toggle = styled(DropdownToggle)`
  width: 25px;
  background: transparent;
  border: none;
  outline: none;
  color: #333333;
  padding: 0;

  :hover, :active, :focus {
    border: none;
    box-shadow: none;
    border-radius: 4px !important;
    background: transparent !important;
    color: #333333 !important;
    outline: none !important;
  }
`

const Item = styled(DropdownItem)`
  display: flex;
  align-items: center;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};

  svg {
    margin-right: 12px;
  }
`

const InputWrapper = styled.div`
  position: relative;

  .tooltip {
    padding: 8px 12px;
    background: #FFFFFF;
    border: 1px solid #EAEAEA;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    color: #808080;
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    transition: opacity 0s ease;
    opacity: 0;
    transform: scaleY(0);
  }

  ${p => p.is_edit === 'true' && `
    :hover {
      .tooltip {
        transition: all 0s ease;
        transition-delay: 0.3s;
        opacity: 1;
        transform: scaleY(1);
      }
    }
  `}
`

const Text = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #333333;
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-cost-planning/tab-pane-other-service/input-row.js